




















































































































import { PointOfInterest } from '@/models/pointOfInterest';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Point } from '../models/point';

@Component
export default class MapLeftSidebar extends Vue {
  @Prop() private selectedPoint!: Point | null;

  private get pointOfInterest(): PointOfInterest | null {
    return this.selectedPoint?.pointOfInterest ?? null;
  }

  private get googleMapsLink(): string {
    return this.pointOfInterest !== null
      ? `https://www.google.com/maps/search/?api=1&query=${this.pointOfInterest.wgs84Latitude},${this.pointOfInterest.wgs84Longitude}`
      : '';
  }

  private onCloseClick() {
    this.$emit('close');
  }
}
